import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { StaffProfileData, StaffProfileIncluded, StaffProfileResponse } from '../types/profile.type'

export const useProfile = ({ isLoggedIn }: { isLoggedIn?: boolean } = {}) => {
  const queryClient = useQueryClient()

  const { data: profileResponse, isLoading: profileIsLoading } = useQuery<StaffProfileResponse>({
    enabled: isLoggedIn,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<StaffProfileResponse>('/profile')
      return data
    },
    queryKey: ['profile']
  })

  const { mutateAsync: updateProfileSignature, isPending: isUpdatingProfileSignature } = useMutation({
    mutationFn: async (signature: string) => {
      const { data } = await AXIOS_INSTANCE.patch('/profile', { signature })
      return data
    },
    mutationKey: ['profile', 'signature'],
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['profile'] })
    }
  })

  return {
    included: (profileResponse?.included || []) as StaffProfileIncluded[],
    profile: profileResponse?.data as StaffProfileData | undefined,
    profileIsLoading,
    facilityId: (profileResponse?.data as StaffProfileData | undefined)?.relationships?.facility?.data?.id,
    updateProfileSignature,
    isUpdatingProfileSignature
  }
}
